import React,{useEffect} from 'react';

function Canvas() {

// variables used to get mouse position on the canvas
    var offsetX;
    var offsetY;


// variables to save last mouse position
// used to see how far the user dragged the mouse
// and then move the text by that distance
    var startX;
    var startY;

// some text objects
    var texts = [];



// calculate width of each text for hit-testing purposes


// this var will hold the index of the selected text
    var selectedText = -1;
    var lastSelected = -1;
    var TextHover ="default";


// START: draw all texts to the canvas
    useEffect(() => {
        draw();
    });



// clear the canvas draw all texts
    function draw() {
        var canvas = document.getElementById('my_canvas');
        var ctx = canvas.getContext('2d');
        offsetX = canvas.offsetLeft;
        offsetY = canvas.offsetTop;
        ctx.font = "16px verdana";

           for (var i = 0; i < texts.length; i++) {
            var text = texts[i];
            text.width = ctx.measureText(text.text).width;
            text.height = 16;
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        canvas.style.cursor=TextHover;
        for (var i = 0; i < texts.length; i++) {
            var text = texts[i];
            ctx.fillStyle = text.color;
            ctx.rotate(text.r * Math.PI / 180);
            ctx.fillText(text.text, text.x, text.y);
        }
    }

    function Selected() {
        var text;
        if(selectedText>-1) {
            text = texts[lastSelected];
            text.color='Red';

            draw();

        }
        else if(lastSelected>-1){
            text = texts[lastSelected];
            text.color='Black';

            draw();
        }
    }

// test if x,y is inside the bounding box of texts[textIndex]
    function textHover(x, y, textIndex) {
        var text = texts[textIndex];
        return (x >= text.x && x <= text.x + text.width && y >= text.y - text.height && y <= text.y);
    }

    function handleMouseTrack(e) {
        if (selectedText > -1) {
            return;
        }
       e.preventDefault();
        startX = parseInt(e.clientX - offsetX);
        startY = parseInt(e.clientY - offsetY);


        for (var i = 0; i < texts.length; i++) {
            if (textHover(startX, startY, i)) {
                TextHover='move';

            }

        }
        console.log(TextHover);

    }

// test if x,y is inside the bounding box of texts[textIndex]
    function textHittest(x, y, textIndex) {
        var text = texts[textIndex];
        return (x >= text.x && x <= text.x + text.width && y >= text.y - text.height && y <= text.y);
    }


// handle mousedown events
// iterate through texts[] and see if the user
// mousedown'ed on one of them
// If yes, set the selectedText to the index of that text
    function handleMouseDown(e) {
        e.preventDefault();
        startX = parseInt(e.clientX - offsetX);
        startY = parseInt(e.clientY - offsetY);

        // Put your mousedown stuff here
        for (var i = 0; i < texts.length; i++) {
            if (textHittest(startX, startY, i)) {
                selectedText = i;
                lastSelected = selectedText;
                Selected();
                console.log(selectedText);
            }
        }
    }

// done dragging
    function handleMouseUp(e) {
        e.preventDefault();
        selectedText = -1;
        console.log(selectedText);
    }

// also done dragging
    function handleMouseOut(e) {
        e.preventDefault();
        selectedText = -1;
        Selected();
        console.log(selectedText);
    }



// handle mousemove events
// calc how far the mouse has been dragged since
// the last mousemove event and move the selected text
// by that distance
    function handleMouseMove(e) {
         TextHover="default";
         handleMouseTrack(e);
        if (selectedText < 0) {
            return;
        }
        e.preventDefault();
       var mouseX = parseInt(e.clientX - offsetX);
       var  mouseY = parseInt(e.clientY - offsetY);

        // Put your mousemove stuff here
        var dx = mouseX - startX;
        var dy = mouseY - startY;
        startX = mouseX;
        startY = mouseY;

        var text = texts[selectedText];
        text.x += dx;
        text.y += dy;
        draw();
    }










    function Text(input) {
         var random_number = Math.random() * 200;
         // Add text to list
        texts.push({
            text:input,
            color:'Black',
            x: 20+random_number,
            y: 50+random_number,
            r:0,
        });
        draw();


    }
    function AddText(e) {
        Text(e.target.innerHTML)

    }

    function AddText2() {
        drawTextInBox('This is a line', 'Arial', 2, 2, 60, 20);

        drawTextInBox('Another line here', 'Arial', 2, 32, 160, 40, 0.1);

        drawTextInBox('The Last line', 'Arial', 2, 82, 220, 90);

        drawTextInBox('! Now with an angle !', 'Arial', 42, 190, 120, 30, -Math.PI/12);

    }





    function drawTextInBox(txt, font, x, y, w, h, angle) {
        var canvas = document.getElementById('my_canvas');
        var ctx = canvas.getContext('2d');
        angle = angle || 0;
        var fontHeight = 20;
        var hMargin = 4;
        ctx.font = fontHeight + 'px ' + font;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'top';
        var txtWidth = ctx.measureText(txt).width + 2 * hMargin;
        ctx.save();
        ctx.translate(x+w/2, y);
        ctx.rotate(angle);
        ctx.strokeRect(-w/2, 0, w, h);
        ctx.scale(w / txtWidth, h / fontHeight);
        ctx.translate(hMargin, 0)
        ctx.fillText(txt, -txtWidth/2, 0);
        ctx.restore();
    }





        return (
            <div className="container p-5">
                <div className="d-flex">
                    <section className="Tools p-5">
                       <button className="btn btn-success" onClick={AddText}>
                           HEADING TEXT
                       </button>

                        <button className="btn btn-success" onClick={AddText}>
                            PARAGRAPH TEXT
                        </button>
                        <button className="btn btn-success" onClick={AddText2}>
                          TEXT
                        </button>

                    </section>
                    <section className="preview p-5">


                           <canvas id="my_canvas" width="400" height="700" className="bg-white"
                                   onMouseDown={handleMouseDown}
                                   onMouseUp={handleMouseUp}
                                   onMouseMove={handleMouseMove}
                                   onMouseOut={handleMouseOut}
                                   />




                    </section>



                </div>
            </div>
        );

}

export default Canvas;